import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";import {MoreVert as MoreVertIcon} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import FlatButton from '../../../../components/FlatButton'
import ProviderActions from '../../../../components/ProviderActions'
import RowInfoCopy from '../../../../components/Row/RowInfoCopy'
import {useDialogState} from '../../../../ui/Dialog/useDialogState'
import {Menu} from '../../../../ui/Menu/Menu'
import {MenuContent} from '../../../../ui/Menu/MenuContent'
import {MenuItem} from '../../../../ui/Menu/MenuItem'
import EditGitLabProviderDialog from './EditGitLabProviderDialog'
import RemoveIntegrationProviderDialog from './RemoveIntegrationProviderDialog'





const GitLabProviderRow = (props) => {
  const {integrationProviderRef} = props
  const integrationProvider = useFragment(
    graphql`
      fragment GitLabProviderRow_integrationProvider on IntegrationProviderOAuth2 {
        id
        serverBaseUrl
        ...EditGitLabProviderDialog_integrationProvider
        ...RemoveIntegrationProviderDialog_integrationProvider
      }
    `,
    integrationProviderRef
  )
  const {id, serverBaseUrl} = integrationProvider

  const {isOpen: isEditOpen, open: openEdit, close: closeEdit} = useDialogState()
  const {isOpen: isDeleteOpen, open: openDelete, close: closeDelete} = useDialogState()

  return (
    _jsxs(_Fragment, { children: [
      _jsxs('div', { className: "flex-center flex items-center border-t border-slate-300 p-4"     , children: [
        _jsxs('div', { className: "flex flex-col px-2"  , children: [
          _jsx('div', { className: "font-semibold text-slate-700" , children: 
            serverBaseUrl.replace(/https:\/\//, '')
          })
          , _jsx(RowInfoCopy, {})
        ]})
        , _jsx(ProviderActions, { children: 
          _jsx(Menu, {
            modal: false,
            trigger: 
              _jsx(FlatButton, { className: "p-2", children: 
                _jsx(MoreVertIcon, {} )
              })
            ,
 children: 
            _jsxs(MenuContent, { children: [
              _jsx(MenuItem, { onClick: openEdit, children: "Edit"})
              , _jsx(MenuItem, { onClick: openDelete, children: "Delete"})
            ]})
          })
        })
      ]}, id)
      , _jsx(EditGitLabProviderDialog, {
        isOpen: isEditOpen,
        onClose: closeEdit,
        integrationProviderRef: integrationProvider,}
      )
      , _jsx(RemoveIntegrationProviderDialog, {
        isOpen: isDeleteOpen,
        onClose: closeDelete,
        integrationProviderRef: integrationProvider,}
      )
    ]})
  )
}

export default GitLabProviderRow
